import React from 'react';
import styles from './drawerContent.module.scss';
import { SearchInput } from '@/components/ui/search-input';
import Skeleton from 'react-loading-skeleton';
import { renderSkeletons } from '../skeleton';
import Link from 'next/link';
import IconClose from '@/assets/icons/icon-round-close.svg';

const RightSectionEmty = ({ closeButton }: { closeButton: () => void }) => {
  return (
    <div className={styles.drawer__rightSection}>
      <div className={styles.drawer__rightSectionContent}>
        <div className={styles.drawer__rightSectionHeader}>
          <div className={styles.drawer__rightSectionInput}>
            <SearchInput />
          </div>
        </div>
        <div className={styles.drawer__rightSectionSubCategories}>
          <h3 className={`${styles.subTitle} ${styles.skeletonForMobile}`}>
            <Skeleton />
          </h3>
          <div className={styles.subCategoriesBrands}>
            {renderSkeletons(
              3,
              `${styles.subCategoriesBrandsBrand} ${styles.skeletonForMobile}`
            )}
          </div>
          <div className={styles.subCategoriesBrandsLinks}>
            {Array.from({ length: 3 }).map((_, index) => (
              <div
                key={index}
                className={styles.subCategoriesBrandsSmartphones}
              >
                <h3 className={`${styles.skeletonForMobile}`}>
                  <Skeleton />
                </h3>
                {Array.from({ length: 3 }).map((_, index) => (
                  <Link
                    href="#"
                    key={index}
                    className={`${styles.skeletonForMobile}`}
                  >
                    <Skeleton />
                  </Link>
                ))}
              </div>
            ))}
          </div>
          <div className={styles.popularCategory}>
            <h3
              className={`${styles.popularCategoryTitle} ${styles.skeletonForMobile}`}
            >
              <Skeleton />
            </h3>
            <div className={styles.popularItems}>
              {Array.from({ length: 3 }).map((_, index) => (
                <div className={styles.item} key={index}>
                  <div
                    className={`${styles.ImageCard} ${styles.skeletonForMobile}`}
                  >
                    <Skeleton />
                  </div>
                  <div className={styles.itemLinks}>
                    <h3 className={`${styles.skeletonForMobile}`}>
                      <Skeleton />
                    </h3>
                    {Array.from({ length: 3 }).map((_, index) => (
                      <Link
                        href="#"
                        key={index}
                        className={`${styles.skeletonForMobile}`}
                      >
                        <Skeleton />
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.drawer__rightSectionAds}>
        <button
          type="button"
          className={styles.drawer__closeButton}
          onClick={closeButton}
        >
          <IconClose />
        </button>
        <div className={`${styles.skeletonForSidebarImg}`}>
          <Skeleton />
        </div>
      </div>
    </div>
  );
};

export default RightSectionEmty;
